import { useEffect } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getWorkflows } from '@/services/api'
import { prefetchWorkflowOrderConfirmationSettings } from '@/features/order-confirmation/workflowOrderConfirmationSettingsQueries'
import { useActingAs } from '@/state/actingAs'

/** Prefetch OC workflow settings once workflows are available (after sign-in). */
export function PrefetchOcWorkflowSettings() {
  const queryClient = useQueryClient()
  const actingAs = useActingAs()

  // Keyed by the acting-as org so this doesn't collide with WorkflowPage's/the
  // sidebar's cache entry for the same query.
  const { data: workflows } = useQuery({
    queryKey: ['workflows', actingAs?.organizationId ?? null],
    queryFn: getWorkflows,
  })

  useEffect(() => {
    if (!workflows?.length) return
    prefetchWorkflowOrderConfirmationSettings(queryClient, workflows)
  }, [workflows, queryClient])

  return null
}
